$.fn.phoneFormat = function() {

	return this.each(function() {
		var $phone = $(this);

		function parsePhoneNo() {
			$phone.val($phone.val().replace(/[^\d-\s]/g, ''));
		}
		function setEvents(){
			$phone.on('blur', function(){
				parsePhoneNo();
			});
		}
		function init(){
			setEvents();
		}

		init();
	});
};
